import { observable, makeObservable } from 'mobx';
import {HttpPromiseState} from '../../../lib/helpers';
import {Classroom} from '../../classroom/models/classroom-models';
import {ClassroomLoaders} from '../../classroom/stores/classroom-loaders';

export class ClassroomDetailsSceneStore {
  @observable.ref
  state: HttpPromiseState<Classroom> | null;

  constructor(readonly classroomId: number) {
    makeObservable(this);
    this.state = null;
  }

  load() {
    if (this.state?.isPending === true)
      return;
    this.state = ClassroomLoaders.Admin.getClassroom(this.classroomId);
  }
}
